import { SvgIcon, SvgIconProps } from '@mui/material';

import { locator } from '../../../testing/e2e-locator/locator';

/**
 * Custom CheckBox icon that uses MUI's CheckBoxIcon design.
 * Cropped viewBox from "0 0 24 24" to "3 3 18 18" to remove all padding and make path fill 24x24px.
 * See: https://mui.com/material-ui/material-icons/?query=checkbox&selected=CheckBox
 */
export const CheckBoxIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon
    {...props}
    data-testid={locator.components.checkboxIcon.root}
    viewBox="3 3 18 18"
  >
    <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
  </SvgIcon>
);
